import { Scope } from '../configs/shared';
import { performanceTargets as page } from '../configs/tools/shared-library/performance-targets';

export const performanceTargets = {
  id: 'performance-targets',
  name: _TL_('Performance Targets'),
  description: _TL_('Set targets and review performance for groups of campaigns.'),
  oldUIScope: [Scope.Account],
  children: [
    page,
  ],
};
